export default "__VITE_ASSET__Hbeb6T3S__"